import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string,
    type: PropTypes.string,
    usagePeriods: PropTypes.arrayOf(
      PropTypes.shape({
        period: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        usageData: PropTypes.arrayOf(
          PropTypes.shape({
            icon: PropTypes.string,
            isUnlimited: PropTypes.bool,
            name: PropTypes.string,
            totalAmount: PropTypes.number,
            totalUnits: PropTypes.string,
            usageType: PropTypes.string,
            usedAmount: PropTypes.number,
            usedUnits: PropTypes.string,
            valuePercentage: PropTypes.string,
          }),
        ),
      }),
    ),
  }),
);
